import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmCreateTicketError = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {isOpen, onSubmit, msgConfirm} = props;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        props.setIsOpen(false);
    };

    const onPressConfirm = () => {
        onSubmit();
        props.setIsOpen(false);
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                {msgConfirm ? msgConfirm : trI18n('COMMSG030')}
                    {/* <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton> */}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action" style={{justifyContent: 'center'}}>
                <Button
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onPressConfirm}
                >
                    {trI18n('COMBTN002')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
